//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ["controlItem"],

  computed:{
    cellClass:function(){
      return { 
          'van-cell': true, 
          'van-field':true,
          'van-cell--required':this.controlItem.IsRequired,
      };
    },
  },

  data() {
    return {

      ThisText:'',
      ThisValue:'',

      ThisDataItem : null,
      
    };
  },
  
  created() {
    if(this.controlItem && this.controlItem.SelectDataList&& this.controlItem.SelectDataList.length > 0){

      var dataItem = this.controlItem.SelectDataList.find(m=>m.Selected);
      if(dataItem && dataItem.Text){

        this.ThisText = dataItem.Text;
        this.ThisValue = dataItem.Value;

        this.ThisDataItem = dataItem;

        this.controlItem.ControlValue = dataItem.Value
      }

    }    
    
  },

  methods: {

    async doEvent(){

      var $e = this.$cmd.checkEvent(this.controlItem,"OnChange");
      if (!$e) return;

      var $cmd = $e.Cmd;
      if (!$cmd) return;

      var url = $cmd.CommandText;
      await this.$parent.$repostForm(url);
      return;

    },   


    onRadioClick(dataItem){

      console.log("dataItem",dataItem);
      this.ThisDataItem = dataItem;
      this.ThisValue = dataItem.Value;
      
      if(this.controlItem){
        this.controlItem.ControlValue = dataItem.Value;
      }
      this.doEvent();
    },

    onHelpIconClick($event){
      //console.log("OnHelpIconClick-$event",$event);
      if(this.controlItem && this.controlItem.HelperText){
        this.$msg.toast(this.controlItem.HelperText);
      }else{
        this.$msg.toast("没有找到帮助信息");
      }
    },

  }
};
